/* React hooks */
import {useEffect, useState} from "react";
/* Components*/
import FormInputs from "../FormInputs";
import useData from "../../hooks/useData";
import {updateEstimateLine} from "../../api/admin/estimateReq";
import useAuth from "../../hooks/useAuth";
import {useParams} from "react-router-dom";
import FormButtons from "../../components/common/FormButtons";
import {checkRequiredFields, getErrorListFromValidation, removeErrorList, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormEstimation({ setShowCreateModal, setShowUpdateModal , section, legend, apiEstimateTemplateList, apiEstimateLine }) {

    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const {estimateLine, estimateDetails, estimateSectionList,} = useData();
    const [values, setValues] = useState();

    // Trouver la section correspondante par sa valeur (7A, 7B, etc.) plutôt que par index
    const currentSection = estimateSectionList?.find(sec => sec.section === id);

    const getTvaRateDisplay = (tvaRate) => {
        const rates = {
            1: "0.00%",
            2: "3.00%",
            3: "20.00%"
        };
        return rates[tvaRate] || "0.00%";
    };

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        if (e.target.type === "checkbox") {
            setValues({...values, [e.target.name] : e.target.checked})
        }
        validateFormInput(e)
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: values?.id || 0,
            description: values?.description,
            comment: values?.comment,
            dataInput: values?.dataInput,
            usualAvailable: values?.usualAvailable,
            complementaryAvailable: values?.complementaryAvailable,
            tvaRate: parseInt(values?.tvaRate) || 0,
            section: currentSection?.section,
            sectionLine: values?.sectionLine
        }
        updateEstimateLine(token, body)
            .then((response) => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    setShowCreateModal(false)
                    setShowUpdateModal(false)
                    apiEstimateTemplateList()
                    apiEstimateLine()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    useEffect(() => {
        setValues(estimateLine)
    }, [ estimateLine ]);

    const handleRemoveModal = () => {
        setShowCreateModal(false)
        setShowUpdateModal(false)
    };

    const inputs = [
        {
            id : 1,
            name : "description",
            type : "textarea",
            placeholder : "Description",
            label : "Description",
        },
        {
            id : 8,
            name : "comment",
            type : "textarea",
            placeholder : "Commentaire (complément de la description, en petit)",
            label : "Commentaire (complément de la description, en petit)",
        },
    ];

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon span={legend} source="fa fa-calculator" />}
                <h3>Section de devis</h3>
                <div className="flex">
                    <div className="form-input">
                        <label>Numéro de section</label>
                        <span>{currentSection?.section}</span>
                    </div>
                    <div className="form-input">
                        <label>Description</label>
                        <span>{currentSection?.description}</span>
                    </div>
                </div>
                { estimateLine?.id &&
                    <div className="form-input">
                        <label>Ligne à modifier</label>
                        <span>{estimateLine?.sectionLine}</span>
                    </div>
                }

                <p className="estimate-comment">"<b>Données</b>" indique si une donnée supplémentaire sera à saisir dans la description, si c'est le cas mettre le code à l'emplacement souhaité de la façon suivante :
                    <br/><em>$_data_.</em> La donnée saisie par le partenaire sera alors automatiquement remplacée.
                    <br/><br/>Les cases à cocher "<b>Obligatoires</b>", "<b>Non obligatoires</b>" et "<b>Frais</b>" correspondent à la disponibilité des cases de prix lors de la saisie, respectivement :
                    <br/>"Prix TTC des prestations <b>obligatoires</b>", <br/>"Prix TTC des prestations <b>non obligatoires</b>".</p>
                {inputs.map(input =>(
                    <FormInputs
                        type={ input.type }
                        name={ input.name }
                        id={ input.id }
                        label={input.label}
                        placeholder={ input.placeholder }
                        value={ values?.[input.name] }
                        onChange={ onChange }
                        required={ input.required }
                        options={ input.options }
                        selected={ input.selected }
                        multiple={ input.multiple }
                        key={ input.id+input.name }
                        pattern={ input.pattern }
                        className={ input.className }
                    />
                ))}
                    <div className="form-input">
                        <label htmlFor="dataInput">Données</label>
                        <input type="checkbox" name="dataInput" id="dataInput" checked={values?.dataInput} onChange={onChange}/>
                    </div>
                    <div className="form-input">
                        <label htmlFor="usualAvailable">Obligatoire TTC</label>
                        <input type="checkbox" name="usualAvailable" id="usualAvailable" checked={values?.usualAvailable} onChange={onChange}/>
                    </div>
                    <div className="form-input">
                        <label htmlFor="complementaryAvailable">Non obligatoire TTC</label>
                        <input type="checkbox" name="complementaryAvailable" id="complementaryAvailable" checked={values?.complementaryAvailable} onChange={onChange}/>
                    </div>
                    <div className="form-input">
                        <label className="required">Taux de TVA</label>
                        <select name="tvaRate" value={values?.tvaRate} onChange={onChange} required>
                            <option value={1}>0.00%</option>
                            <option value={2}>3.00%</option>
                            <option value={3}>20.00%</option>
                        </select>
                    </div>
                    {/*<div className="form-input">
                        <label htmlFor="familyFeeAvailable">Frais</label>
                        <input type="checkbox" name="familyFeeAvailable" id="familyFeeAvailable" checked={values?.familyFeeAvailable} onChange={onChange}/>
                    </div>*/}

                <div className="dashboard">
                    <table>
                        <thead className="dashboard-header">
                        <tr>
                            <th>Numéro de ligne</th>
                            <th>Description</th>
                            <th>Données</th>
                            <th>Prestations obligatoires TTC</th>
                            <th>Prestations non obligatoires TTC</th>
                            <th>Tva</th>
                        </tr>
                        </thead>
                        <tbody>
                        {estimateDetails?.map(line => (
                            <tr key={line?.id}>
                                <td><span>{line?.sectionLine}</span></td>
                                <td><span>{line?.description}<br/><span>{line?.comment}</span></span></td>
                                <td><input disabled={true} type="checkbox" defaultChecked={line?.dataInput}/></td>
                                <td><input disabled={true} type="checkbox" defaultChecked={line?.usualAvailable}/></td>
                                <td><input disabled={true} type="checkbox" defaultChecked={line?.complementaryAvailable}/></td>
                                <td><span>{getTvaRateDisplay(line?.tvaRate)}</span></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>
    )
}
